import { connect } from "mqtt";
import React, { useEffect } from "react";

const MqttDataOpen = ({ topics, setMqttTagData, allData }) => {

  useEffect(() => {
    const mqttBrokerAddress = process.env.REACT_APP_MQTT_URL;
    const mqttUsername = process.env.REACT_APP_MQTT_USERNAME; // Replace 'your-username' with the actual username
    const mqttPassword = process.env.REACT_APP_MQTT_PASSWORD; // Replace 'your-password' with the actual password

    const getTagTime = () => {
      return new Date().toLocaleTimeString("en-US", {
        timeZone: "UTC", // Fallback to 'UTC' if null
        hour12: false,
      });
    };

    const getTagDateAndTime = () => {
      return new Date().toLocaleString("en-US", {
        timeZone: "UTC", // Fallback to 'UTC' if null
        hour12: false,
      });
    };

    const getTagDateAndTimeFormat = () => {
      const options = {
        timeZone: "UTC", // Fallback to 'UTC' if null
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };

      const dateTimeString = new Date().toLocaleString("en-US", options);
      const [month, day, year, hour, minute, second] =
        dateTimeString.match(/\d+/g);

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    };

    const mqttClient = connect(mqttBrokerAddress, {
      username: mqttUsername,
      password: mqttPassword,
      rejectUnauthorized: false,
    });

    mqttClient.on("connect", () => {
      console.log("Connected to MQTT broker");
    });

    mqttClient.on("message", (topics, message) => {
      try {
        const messageString = message.toString();
        // console.log("messageString", messageString);
        const tags = topics.split("/").slice(-2).join("/");
      
        const data = JSON.parse(`[${messageString.replace(/}{/g, "},{")}]`);

  
        const formattedMessage = data.map((obj) => {
          const device_tag = Object.keys(obj)[0];
          const tagUnit = allData
            ? allData.find((f) => f.mqtt_topic.split("/").slice(-2).join("/") === tags)?.production_line_station_name
            : "";
     

          const tagValue = obj[device_tag];

          return {
            tagValue: tagValue,
            mqtt_topic: tags,
            device_tag,
            [device_tag]: tagValue,
            machineName: tagUnit,
            tagTime: getTagTime(),
            tagDateAndTime: getTagDateAndTime(),
            tagDateAndTimeFormat: getTagDateAndTimeFormat(),
          };
        });

        setMqttTagData((prevData) => {
            const updatedData = { ...prevData };
            const existingData = updatedData[tags] || [];
          
            // Append all new messages instead of limiting to 10
            updatedData[tags] = [...existingData, ...formattedMessage]; 
          
            console.log(`Messages stored for topic '${tags}':`, updatedData[tags].length); // Debugging count
            console.log(`Messages received in this batch:`, formattedMessage.length); // Debugging count
          
            return updatedData;
          });
          
        
      } catch (error) {
        console.log("Error handling message: ", error);
      }
    });

    mqttClient.on("error", (error) => {
      console.log("MQTT error: ", error);
    });

    const intervalId = setInterval(() => {
      // Code to execute every 3 seconds
      mqttClient.subscribe(topics);
    }, 3000);

    return () => {
      clearInterval(intervalId); // Clear the interval when the component is unmounted
      mqttClient.end(); // Disconnect the MQTT client
    };
  }, [topics, allData, setMqttTagData]);

  return <></>;
};

export default MqttDataOpen;